

import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../utils/error-handler';
import { environment } from '../../environments/environment';
import { OverlayPanel } from 'primeng/overlaypanel';
import { CarrierService } from '../carrier/carrier.service';
import { Globals } from '../globals';
import { SelectableLab } from '../carrier/selectable-lab';
import { MenuItem } from 'primeng/api';
import { LabEmitterService } from '../common-services/lab-emitter.service';
import { Router } from '@angular/router';
import { AuthUtil } from '../common-services/auth-util';
import * as jwt_decode from 'jwt-decode'

// Header menu to handle navigation. This is dynamic menu and it has to be handled based on lab selection
// Author: Naveen
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    buildNo: string;
    sampleReceptionServiceBuildNo: string;
    qcSampleServiceBuildNo: string;
    printServiceBuildNo: string;
    ticketServiceBuildNo: string;
    mdmServiceBuildNo: string;
    swabSampleReceptionServiceBuildNo: string;
    apiGatewayServiceBuildNo: string;
    marvelMessagingServiceBuildNo: string;
    orderReceptionServiceBuildNo: string;
    //dmsServiceBuildNo: string;
    sequencingServiceBuildNo: string;
    shipmentServiceBuildNo: string;
    orderCreationServiceBuildNo: string;
    mailReceptionServiceBuildNo: string;
    qcReportManagementServiceBuildNo: string;
    storageBuildNo: string;
    ngsEntryQcBuildNo: string;
    ngsLibPrepBuildNo: string;
    apgServiceBuildNo: string;
    animalInterfaceBuildNo: string;
    nonPremixDataDeliveryServiceBuildNo: string;

    production: boolean;
    errorHandler: ErrorHandler = new ErrorHandler;

    selectedLab: SelectableLab;
    loggedUserName: string;

    isMPC: boolean = false;
    isNGS: boolean = false;
    isAPG: boolean = false;
    otherLab: boolean = false;
    isSanger: boolean = false;
    isGenotyping: boolean = false;

    readonly COLOGNE = "COLOGNE"
    readonly AARHUS = "AARHUS"
    readonly EBERSBERG = "EBERSBERG"
    readonly MPC_EBE = "MPC_EBE"
    readonly NGS_CONSTANCE = "NGS_CONSTANCE"
    readonly APG = "APG"

    readonly BU_SANGER = "Sanger Sequencing"
    readonly BU_GENOTYPING = "Genotyping"
    readonly BU_NGS = "Next Generation Sequencing"
    readonly BU_APG = "Applied Genomics"

    link: MenuItem[];

    constructor(private _globals: Globals, private router: Router, private _carrierService: CarrierService, private _labEmitterService: LabEmitterService) { }

    // initilizes the build info
    ngOnInit() {

        this.initializeBuildInfo();
        this.getBuildInfo();
        this.getServiceBuildInfo();


        this._labEmitterService.change.subscribe(lab => {
            this.selectedLab = lab;
            console.log("Seleted lab in header(e): " + this.selectedLab.label)
            this.checkSelectedLab()
        });

        this.selectedLab = JSON.parse(localStorage.getItem('lab'));
        if (this.selectedLab) {
            console.log("Seleted lab in header: " + this.selectedLab.label)
            this.checkSelectedLab()
        }

        this.production = environment.production;

        this.link = [
            {
                label: 'Change Lab', command: () => {
                    this.changeLab();
                }
            }
        ];

    }

    get loginStatus() {
        return localStorage.getItem('currentUser') ? true : false;
    }
    
    get azureLoginStatus() {
        let authUtil = new AuthUtil()
        let accessToken = authUtil.getAccessToken()
        if(accessToken)
        {
        let access_token = jwt_decode(accessToken);
        this.loggedUserName= access_token.name;
        let loggedUserPUID = this.getUniqueName(access_token.unique_name);
        localStorage.setItem('PUID', loggedUserPUID);
        }
        return accessToken ? true : false
    }

    logOut() {
        localStorage.removeItem('currentUser');
    }

    azureLogOut() {
        const util = new AuthUtil()
        util.logout()

    }

    // checks the selected lab
    checkSelectedLab() {
        switch (this.selectedLab.lab.businessArea.name) {
            case this.BU_SANGER: {
                this.isSanger = true;
                break;
            }
            case this.BU_GENOTYPING: {
                this.isGenotyping = true;
                break;
            }
            case this.BU_APG: {
                this.isAPG = true;
                break;
            }
            case this.MPC_EBE: {
                this.isMPC = true;
                break;
            }
            case this.BU_NGS: {
                this.isNGS = true;
                break;
            }

            default: {
                this.otherLab = true;
                break;
            }
        }
    }

    // chnages the lab and loads lab page
    changeLab() {

        this.isMPC = false;
        this.isNGS = false;

        this.otherLab = false;
        this.isSanger = false;
        this.isGenotyping = false;
        this.isAPG = false;
        this.isNGS = false;

        localStorage.removeItem('lab');
        this.router.navigate(['/']).then(nav => {
            console.log(nav); // true if navigation is successful
            if (nav === null) {
                console.log("Reloading...");
                window.location.reload();
            }
        }, err => {
            window.location.reload();
            console.log(err) // when there's an error
        });
    }

    // initilizes the build info
    initializeBuildInfo() {
        this.buildNo = '== DEV ==';
        this.sampleReceptionServiceBuildNo = 'n/a';
        this.qcSampleServiceBuildNo = 'n/a';
        this.printServiceBuildNo = 'n/a';
        this.mdmServiceBuildNo = 'n/a';
        this.ticketServiceBuildNo = 'n/a';
        this.swabSampleReceptionServiceBuildNo = 'n/a';
        this.apiGatewayServiceBuildNo = 'n/a';
        this.marvelMessagingServiceBuildNo = 'n/a';
        this.orderReceptionServiceBuildNo = 'n/a';
        //this.dmsServiceBuildNo = 'n/a';
        this.sequencingServiceBuildNo = 'n/a';
        this.shipmentServiceBuildNo = 'n/a';
        this.orderCreationServiceBuildNo = 'n/a';
        this.mailReceptionServiceBuildNo = 'n/a';
        this.qcSampleServiceBuildNo = 'n/a';
        this.storageBuildNo = 'n/a';
        this.ngsEntryQcBuildNo = 'n/a';
        this.ngsLibPrepBuildNo = 'n/a';
        this.apgServiceBuildNo = 'n/a';
        this.animalInterfaceBuildNo = 'n/a';
    }

    getBuildInfo() {
        console.log("Pulling build info");
        this._carrierService.getBuildInfo().subscribe(
            results => {
                console.log('BUILD: ' + results.Build.Number);
                if (results.Build.Number.length > 0) {
                    this.buildNo = results.Build.Number;
                }
            }
        );
    }

    // service call for the build info
    getServiceBuildInfo() {

        this._carrierService.getServiceBuildInfo(environment.BB_SAMPLE_RECEPTION_SERVICE_URL).subscribe(
            results => {
                console.log("sample reception service : " + results.data.Build.Number);
                this.sampleReceptionServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_QC_SAMPLE_SERVICE_URL).subscribe(
            results => {
                console.log("qc service:" + results.data.Build.Number);
                this.qcSampleServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_PRINT_SERVICE_URL).subscribe(
            results => {
                console.log("print service: " + results.data.Build.Number);
                this.printServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_MDMSERVICE_URL).subscribe(
            results => {
                console.log("MDM service: " + results.data.Build.Number);
                this.mdmServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_TICKET_SERVICE_URL).subscribe(
            results => {
                console.log("Ticket : " + results.data.Build.Number);
                this.ticketServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_ORDERRECEPTION_SERVICE_URL).subscribe(
            results => {
                console.log("Order Reception : " + results.data.Build.Number);
                this.orderReceptionServiceBuildNo = results.data.Build.Number;
            }
        );

        // this._carrierService.getServiceBuildInfo(environment.BB_DMS_SERVICE_URL).subscribe(
        //     results => {
        //         console.log("DMS : " + results.data.Build.Number);
        //         this.dmsServiceBuildNo = results.data.Build.Number;
        //     }
        // );

        this._carrierService.getServiceBuildInfo(environment.BB_SWAB_SAMPLE_RECEPTION_SERVICE_URL).subscribe(
            results => {
                console.log("SwabSample : " + results.data.Build.Number);
                this.swabSampleReceptionServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_APIGATEWAY_SERVICE_URL).subscribe(
            results => {
                console.log("APIGateway : " + results.data.Build.Number);
                this.apiGatewayServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_MARVELMESSAGING_SERVICE_URL).subscribe(
            results => {
                console.log("MarvelMessaging : " + results.data.Build.Number);
                this.marvelMessagingServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_SEQUENCING_SERVICE_URL).subscribe(
            results => {
                console.log("Sequencing service : " + results.data.Build.Number);
                this.sequencingServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_SHIPMENT_SERVICE_URL).subscribe(
            results => {
                console.log("Shipment service : " + results.data.Build.Number);
                this.shipmentServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_ORDER_CREATION_SCHEDULER_URL).subscribe(
            results => {
                console.log("Order Creation service : " + results.data.Build.Number);
                this.orderCreationServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_MAIL_RECEPTION_URL).subscribe(
            results => {
                console.log("Mail Reception service : " + results.data.Build.Number);
                this.mailReceptionServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_QC_REPORT_MANAGEMENT_URL).subscribe(
            results => {
                console.log("QC Report Management Service: " + results.data.Build.Number);
                this.qcReportManagementServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_STORAGE_URL).subscribe(
            results => {
                console.log("Storage Service: " + results.data.Build.Number);
                this.storageBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_NGS_ENTRY_QC_URL).subscribe(
            results => {
                console.log("NGS Entry QC Service: " + results.data.Build.Number);
                this.ngsEntryQcBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_NGS_LIB_PREP_URL).subscribe(
            results => {
                console.log("NGS Lib Prep Service: " + results.data.Build.Number);
                this.ngsLibPrepBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_APG_SAMPLE_PROCESSING_URL).subscribe(
            results => {
                console.log("APG Animal Samples Service: " + results.data.Build.Number);
                this.apgServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_ANIMAL_ORDER_SERVICE_URL).subscribe(
            results => {
                console.log("Animal Order/Interface Service: " + results.data.Build.Number);
                this.animalInterfaceBuildNo = results.data.Build.Number;
            }
        )

        this._carrierService.getServiceBuildInfo(environment.BB_APG_NC_HANDLING_URL).subscribe(
            results => {
                console.log("APG NC Handling Service: " + results.data.Build.Number);
                this.apgServiceBuildNo = results.data.Build.Number;
            }
        );

        this._carrierService.getServiceBuildInfo(environment.BB_NON_PREMIX_DATA_DELIVERY).subscribe(
          results => {
              console.log("Non-Premix Data Delivery Service: " + results.data.Build.Number);
              this.nonPremixDataDeliveryServiceBuildNo = results.data.Build.Number;
          }
      );
    }

    // binding build info
    showBuildInfo(event, overlaypanel: OverlayPanel) {
        overlaypanel.toggle(event);
    }

    getUniqueName(unique_name: string) {
        return unique_name.includes('@') ? unique_name.substring(0, unique_name.indexOf('@')) : '';
    }
}
